var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bg-white rounded-circle p-1" }, [
    _c("em", {
      staticClass: "rounded-circle bg-orange text-white p-2",
      class: _vm.i
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }